<template>
  <div class="header">
    <span class="back" @click="back">{{ $t("index.back") }}</span>
  </div>
  <div class="inner">
    <div class="menu">
      <a-menu
        v-model:selectedKeys="current"
        :items="items"
        mode="inline"
        @click="handleClick"
        id="folderMenu"
      />
    </div>
    <div class="tab">
      <a-row :gutter="24" style="margin: 20px -12px">
        <a-col :span="8">
          <a-input v-model:value="searchKey" placeholder="请输入订单编号" />
        </a-col>
        <a-col :span="8">
          <a-button type="primary" @click="loadData()"> 查询 </a-button>
        </a-col>
      </a-row>
      <!-- plm随机文件目录 -->
      <a-table
        v-if="bodorShow"
        ref="table"
        :columns="columns"
        :dataSource="plmCatalog"
        :row-key="(record) => record.Id"
        :loading="loading"
        style="border-radius: 0px"
        :bordered="false"
      >
        <template #operator class="table-operator"> </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <a @click="article(record)">{{ $t("index.look") }}</a>
            <a-divider type="vertical" />
            <!-- <a @click="download(record)">{{ $t("index.download") }}</a> -->
          </template>
        </template>
      </a-table>
      <!-- plm随机文件 -->
      <a-table
        v-else
        ref="table"
        :columns="columns"
        :dataSource="plmList"
        :row-key="(record) => record.Id"
        :loading="loading"
        style="border-radius: 0px"
        :bordered="false"
      >
        <template #operator class="table-operator"> </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <!-- <a @click="articlePlm(record)">{{ $t("index.look") }}</a> -->
            <a-divider type="vertical" />
            <a @click="downloadPlm(record)">{{ $t("index.download") }}</a>
          </template>
        </template>
      </a-table>
    </div>
    <RandomFileForm ref="randomFileFormRef" />
  </div>
</template>

<script setup>
import { h, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { FolderOutlined, FileOutlined } from "@ant-design/icons-vue";
import { useI18n } from "vue-i18n";
import RandomFileForm from "./RandomFileForm.vue";

const { t } = useI18n();

let route = useRoute();
let router = useRouter();

let userId = localStorage.getItem("userId");
const randomFileFormRef = ref("");

const current = ref([]);
const items = ref([]);
const equipmentList = ref([]);

const searchKey = ref();

// 定义tableDOM
const table = ref(null);
// bodor+随机文件
const dataSource = ref([]);
const orderNumber = ref("");
//plm随机文件
const plmCatalog = ref([
  { id: "a01", title: t("index.guide") },
  { id: "a02", title: t("index.instructions") },
  { id: "a03", title: t("index.guidance") },
  { id: "a04", title: t("index.program") },
  { id: "a05", title: t("index.scene") },
  { id: "a06", title: t("index.foundation") },
  { id: "a07", title: t("index.hoisting") },
  { id: "a08", title: t("index.electrical") },
  { id: "a09", title: t("index.cutting") },
  { id: "a10", title: t("index.waterway") },
  { id: "a11", title: t("index.airCircuit") },
  { id: "a12", title: t("index.lubrication") },
  { id: "a13", title: t("index.hydraulic") },
  { id: "a14", title: t("index.refrige") },
  { id: "a15", title: t("index.product") },
  { id: "a16", title: t("index.debug") },
  { id: "a17", title: t("index.repairHand") },
  { id: "a20", title: t("index.automation") },
  { id: "a21", title: t("index.homework") },
  { id: "a22", title: t("index.indicate") },
  { id: "a23", title: t("index.principle") },
  { id: "a24", title: t("index.autoElectrical") },
  { id: "a25", title: t("index.autolubrication") },
  { id: "a26", title: t("index.autohydraulic") },
  { id: "其他", title: t("index.other") },
]);
const plmList = ref([]);
const loading = ref(false);
const bodorShow = ref(true); //plm随机文件目录显示
const plmShow = ref(false); //plm随机文件显示
const httpUrl = ref("https://apicloud.bodor.com");

const columns = [
  {
    title: t("index.knowledgetb1"),
    dataIndex: "title",
  },
  {
    title: t("index.knowledgetb5"),
    dataIndex: "action",
    align: "center",
  },
];

axios
  .post("api/Machine/GetMyMachine", {
    UserId: userId,
  })
  .then((response) => {
    if (response.data.code != 200) {
      message.error(response.data.info);
    } else {
      equipmentList.value = response.data.ReturnData;
      response.data.ReturnData.forEach((item, index) => {
        if (index == 0) {
          current.value.push(item.ordernumber);
        }
        items.value.push({
          key: item.ordernumber,
          label: item.ordernumber,
        });
      });
    }
    searchKey.value = null;
    orderNumber.value = current.value[0];
    // filterData(current.value[0]);
  })
  .catch((error) => {
    console.error(error);
  });

//点击查看目录
const article = (record) => {
  console.log("点击查询目录：", record.id, orderNumber.value);
  randomFileFormRef.value.onOpen(record.id, orderNumber.value);
  // window.open(record.webpath + record.filepath);
  // getPlmFilter({
  //   OrderNumber: orderNumber.value,
  //   FileType: record.id,
  // }).then((response) => {
  //   alert(JSON.stringify(response));
  // });
};

//plm随机文件下载
const downloadPlm = (record) => {
  console.log("plm下载record:", record);
  let url = "https://apicloud.bodor.com" + record.filepath;
  console.log("plm下载url:", url);
  let name = record.title;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      console.log("请求成功==");
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    } else {
      debugger;
      console.log("流程4");
      let link = document.createElement("a");
      //创建一个a标签
      console.log("流程4.14", record.filepath.split("/"));
      link.style.display = "none";
      //将a标签隐藏
      if (record.filepath.split("/")[1] == "Areas") {
        link.href = "https://apicloud.bodor.com" + record.filepath;
        console.log("有Areas: https://apicloud.bodor.com" + record.filepath);
      } else {
        link.href = "https://apicloud.bodor.com/wwwroot" + record.filepath;
        console.log("无Areas: https://apicloud.bodor.com/wwwroot" + record.filepath);
      }

      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      console.log("reocrd.title:", record.title);
      link.setAttribute("download", record.title);
      console.log("此时link", link.href, link.download);
      link.setAttribute("target", "_blank");
      console.log("111111");
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      console.log("222222");
      //将上面创建的a标签加入到body的尾部
      link.click();
      console.log("333333");
    }
  };
  xhr.send();
};

const download = (record) => {
  console.log("自己数据库下载url:", record.filepath);
  let url = "https://apicloud.bodor.com" + record.filepath;
  let name = record.title;
  // 发送http请求，将文件链接转换成文件流
  let xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  // 请求类型
  xhr.responseType = "blob";
  xhr.onreadystatechange = function () {
    // 获取接口结果
    if (xhr.readyState === 4 && xhr.status === 200) {
      window.URL = window.URL || window.webkitURL;
      let a = document.createElement("a");
      let blob = new Blob([xhr.response]);
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name;
      a.click();
      // 销毁创建的url
      window.URL.revokeObjectURL(url);
    } else {
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      if (record.filepath.split("/")[1] == "Areas") {
        link.href = "https://apicloud.bodor.com" + record.filepath;
        console.log("https://apicloud.bodor.com" + record.filepath);
      } else {
        link.href = "https://apicloud.bodor.com/wwwroot" + record.filepath;
        console.log("https://apicloud.bodor.com/wwwroot" + record.filepath);
      }
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download", record.title);
      link.setAttribute("target", "_blank");
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
    }
  };
  xhr.send();
};

const handleClick = (e) => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 1000);
  console.log("点击table:", e);
  orderNumber.value = e.key;
  console.log("点击tableorderNumber:", orderNumber.value);
  searchKey.value = null; //搜索框
  // setTimeout(async function () {
  //   const res = await plmPdfList(orderNumber.value);
  //   console.log("tabalClick:", res.length);
  //   if (res.length) {
  //     console.log("plm中能查询到");
  //     bodorShow.value = true;
  //   } else {
  //     console.log("plm中查不到");
  //   }
  // }, 0);
};

function filterData(searchData) {
  loading.value = true;
  let params;
  if (searchData) {
    params = {
      OrderNumber: searchData,
    };
  } else {
    params = {
      OrderNumber: current.value[0],
    };
  }
  axios
    .post("api/Machine/GetEquipmetFileData", params)
    .then((response) => {
      console.log("response:", response);
      if (response.data.code == 200 && response.data.ReturnType == true) {
        if (
          response.data.ReturnData != null &&
          response.data.ReturnData.length > 0 &&
          response.data.ReturnData != "暂无数据"
        ) {
          plmShow.value = false; //plm随机文件隐藏
          dataSource.value = response.data.ReturnData;
        } else {
          //bodor中无数据
          dataSource.value = [];
          //bodor+搜不到，从plm搜索
          plmPdfList(params).then((fileList) => {
            console.log("plm文件列表返参=：", fileList);
            let newFileList = new Array();
            for (var i = 0; i < fileList.length; i++) {
              let newObj = {
                title: fileList[i].title || "",
                FilePath: fileList[i].filepath,
              };
              newFileList.push(newObj);
            }
            plmShow.value = true; //plm随机文件显示
            // plmList.value = newFileList;
            plmList.value = fileList;
          });
        }
      } else {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
}

//查询plm文件
const getPlmFilter = (params) => {
  alert(JSON.stringify(params));
  return new Promise((resolve, reject) => {
    axios.post("api/RandomCenter/GetPLMRandomFile", params).then((response) => {
      if (response.data.code != 200) {
        reject(response.data.info);
      } else {
        if (response.data.ReturnData != null && response.data.ReturnData.length > 0) {
          resolve(response.data.ReturnData);
        } else {
          reject(t("service.noData"));
        }
      }
    });
  });
};

//点击查询
const loadData = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 1000);
  console.log("点击查询按钮：", searchKey.value);
  if (searchKey.value) {
    current.value = [];
    bodorShow.value = true; //plm目录显示
    orderNumber.value = searchKey.value;
    // filterData(searchKey.value);
  }
};

const back = () => {
  router.push(`/index/use`);
};
</script>

<style scoped>
.menu {
  width: 20%;
  height: 100%;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.inner {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  padding: 0px 2% 0px 0px;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.tab {
  width: 78%;
}
a {
  color: #1890ff;
}
</style>
